'use client';

import './style.sass';

import { listPath, listTitle } from './constants';

import Stages from '../reusable-components/layouts-components__bonum/ stages';
import Advice from '../reusable-components/layouts-components__bonum/advice';
import Complexity from '../reusable-components/layouts-components__bonum/complexity';
import Description from '../reusable-components/layouts-components__bonum/description';
import Goal from '../reusable-components/layouts-components__bonum/goal';
import Results from '../reusable-components/layouts-components__bonum/results';
import Tasks from '../reusable-components/layouts-components__bonum/tasks';
import Team from '../reusable-components/layouts-components__bonum/team';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import Review from '../reusable-components/layouts-components__common-cases/review';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';
import CommonSmallText from '../common-components/common-small-text';

const nextProjectGens = {
    marketing: true,
    nextProjectTitle: 'Не&nbsp;сайт, а&nbsp;сложная экосистема для ежегодного форума',
    nextProjectImg: '/images/svg/projects/projects__img5.png',
    nextProjectLink: '/cases/marketing/rec',
    nextProjectLinkTitle: 'АО&nbsp;&laquo;Российская венчурная компания&raquo;',
    nextProjectText:
        'Помогли семейству продуктов для бизнес-коммуникаций найти себя и&nbsp;много ценной пыльцы.',
};

const review = {
    reviewText:
        'Наша компания сотрудничает с&nbsp;агентством &laquo;Вебпрактик&raquo; более 5&nbsp;лет. Это очень сильная команда профессионалов, которая полностью погрузилась в&nbsp;специфику нашего бизнеса. У&nbsp;них всегда креативный подход и&nbsp;точная, аргументированная стратегия для любой бизнес-задачи.',
    reviewAuthors: [
        {
            img: '/images/pic/bonum/review.png',
            title: 'Надежда Михайленко',
            subtitle: 'Руководитель отдела маркетинга ООО «БОНУМ»',
        },
    ],
};

const Bonum = () => {
    return (
        <section className="bonum">
            <TitleCase
                img="/images/pic/bonum/bonumTitle.jpg"
                caseName="bonum"
                listTitle={listTitle}
                listPath={listPath}
            />

            <FullWrapper className="bonum-subtitle">
                <CommonSmallText className="bonum__text">
                    В этом кейсе благодаря использованию HADI-циклов мы повысили продажи спецтехники
                    и сэкономили рекламный бюджет. Протестировали более 400 гипотез, максимально
                    проработали семантику, использовали контекстный таргетинг и настройки
                    LAL-аудитории.
                </CommonSmallText>
            </FullWrapper>
            <Description />
            <Complexity />
            <Goal />
            <Tasks />
            <Stages />
            <Results />
            <Advice />
            <Team />
            <Review Review={review} />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>
            <NextProject NextProject={nextProjectGens} />
        </section>
    );
};

export default Bonum;
